<app-loader *ngIf="cs.isBrowser && isLoading"></app-loader>
<div class="modal-content modal-theme2 trimVideo-modal">
  <div class="modal-header">
    <h4 class="modal-title">{{labels.CHOOSE_COVER_IMAGE}}</h4>
  </div>
  <div class="modal-body d-flex align-items-start">
    <div class="trimVideo-left trimVideo-video">
      <app-video-player-v3
        #videoPlayer
        [autoPlay]="false"
        [viewShowAgainInMiddle]="true"
        [coverImage]="selectedCoverImage"
        [videoMode]="videoMode"
        [post]="modalInfo"
      ></app-video-player-v3>
    </div>
    <div
      class="trimVideo-right"
      [ngClass]="{
        'right-landscape-container': videoMode === application.LANDSCAPE
      }"
    >
      <div class="w-100 d-flex flex-column gap-4">
        <div class="d-flex justify-content-between align-items-center">
          <div class="head-label">{{labels.COVER_IMAGE}}</div>
          <div class="input-cover-label" (click)="fileInput.click()">
            {{labels.SELECT_FROM_COMPUTER}}
          </div>
          <input
            type="file"
            #fileInput
            [accept]="application.IMAGE_ACCEPT_TYPES_INCLUDING_GIF"
            (change)="onFileSelected($event)"
            style="display: none"
            appMobileBridgeFileInput
            (mobileFileChange)="onFileSelected($event, true)"
            [fileConfig]="{
              isMultiple: false
            }"
          />
        </div>
        <div class="d-flex image-frame-container flex-wrap gap-4">
          <div
            *ngFor="let image of frameArray"
            class="image-frame"
            [ngClass]="{
              'selected-frame': selectedCoverImage.index === image.index,
              'landscape-frame': videoMode === application.LANDSCAPE
            }"
            (click)="setCoverImage(image)"
          >
            <img appDisableRightClick appMobileOptimization [originalUrl]="image.src" [src]="image.src" [format]="'webp'" alt="Thumbnail" loading="lazy" decoding="async" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-watermark-controls
    *ngIf="isWatermark"
    [isVideo]="true"
    [watermarkLabel]="watermarkSettings.watermarkLabel"
    [hint]="WATERMARK_HINT_VIDEO"
    [watermark]="watermark"
    [locationOptions]="VIDEO_REEL_LOCATION_OPTIONS"
    [globalWatermark]="watermarkSettings.globalWatermark"
    (watermarkChange)="onEmitWatermarkChange($event)"
    (globalWatermarkChange)="onEmitApplyGlobalWatermark($event)"
  ></app-watermark-controls>

  <div class="modal-footer mt-lg-4">
    <button (click)="cancel()" class="btn btn-default" type="button">
      {{labels.CANCEL}}
    </button>
    <button
      (click)="trimAndUpload()"
      class="btn btn-primary"
      type="button"
      [disabled]="isConfirming"
    >
      {{labels.UPLOAD}}
    </button>
  </div>
</div>

<video #videoElement class="d-none" preload="auto"></video>
<canvas #canvasElement class="d-none"></canvas>
